export type DemoPerson = {
  id: string
  name: string
  initials: string
  email: string
  /** Framework role id (see data/framework). */
  roleId: string
  title: string
  body: 'Board' | 'Executive Committee'
  committees: string[]
}

export const ORGANISATION = {
  name: 'Meridian Holdings plc',
  shortName: 'Meridian',
  domain: 'meridianholdings.com',
  type: 'Listed company',
  location: 'London, United Kingdom',
}

function person(
  id: string,
  name: string,
  roleId: string,
  title: string,
  body: DemoPerson['body'],
  committees: string[] = [],
): DemoPerson {
  const [first, last] = name.split(' ')
  return {
    id,
    name,
    initials: `${first[0]}${last[0]}`,
    email: `${first.toLowerCase()}.${last.toLowerCase()}@${ORGANISATION.domain}`,
    roleId,
    title,
    body,
    committees,
  }
}

export const PEOPLE: DemoPerson[] = [
  person('p1', 'Eleanor Whitfield', 'board-chair', 'Board Chairperson', 'Board', ['Nominations Committee']),
  person('p2', 'James Adeyemi', 'ceo', 'Chief Executive Officer', 'Executive Committee'),
  person('p3', 'Priya Raman', 'cfo', 'Chief Financial Officer', 'Executive Committee'),
  person('p4', 'Thomas Brennan', 'coo', 'Chief Operating Officer', 'Executive Committee'),
  person('p5', 'Laila Haddad', 'cro', 'Chief Risk Officer', 'Executive Committee'),
  person('p6', 'Marcus Lindqvist', 'cio', 'Chief Information Officer', 'Executive Committee'),
  person('p7', 'Sofia Moreno', 'cmo', 'Chief Marketing Officer', 'Executive Committee'),
  person('p8', 'Richard Okonkwo', 'audit-chair', 'Audit Committee Chair', 'Board', ['Audit Committee']),
  person('p9', 'Helen Carmichael', 'nominations-chair', 'Nominations Committee Chair', 'Board', ['Nominations Committee']),
  person('p10', 'David Asante', 'ined', 'Independent Non-Executive Director', 'Board', ['Audit Committee', 'Risk Committee']),
  person('p11', 'Margaret Ellis', 'ned', 'Non-Executive Director', 'Board', ['Remuneration Committee']),
  person('p12', 'Anika Patel', 'ined', 'Independent Non-Executive Director', 'Board', ['Nominations Committee', 'Remuneration Committee']),
]

export function personById(id: string): DemoPerson {
  return PEOPLE.find((p) => p.id === id) ?? PEOPLE[0]
}

/** The signed-in subscriber administrator in the demo. */
export const CURRENT_ADMIN = {
  name: 'Claire Donovan',
  initials: 'CD',
  title: 'Company Secretary',
  email: `claire.donovan@${ORGANISATION.domain}`,
}

export const COMMITTEES = [
  'Audit Committee',
  'Nominations Committee',
  'Remuneration Committee',
  'Risk Committee',
]
